import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import {keys} from './keys';
import {SESSION_STALE_TIME_MS} from './constants';
import type {IdentityDependencies} from '../dependencies';

export type GetSessionQueryDependencies = Pick<IdentityDependencies, 'controllers'>;

export const getSessionQuery = (dependencies: GetSessionQueryDependencies) =>
  queryOptions({
    queryKey: keys.getSession(),
    queryFn: () => dependencies.controllers.authController.getSession().then(unwrap),
    staleTime: SESSION_STALE_TIME_MS,
  });
